import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToastContainer } from "react-toastify";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { useCurrentPage } from "./hooks/useCurrentPage";
import { AppContextProvider } from "./providers/AppContextProvider";
import { LoadingContextProvider } from "./providers/LoadingContextProvider";
import { ModalContextProvider } from "./providers/ModalContextProvider";
import { PipelinesContextProvider } from "./providers/PipelinesContextProvider";
import { UserContextProvider } from "./providers/UserContextProvider";
function App() {
    const currentPage = useCurrentPage();
    return (_jsx(ErrorBoundary, { children: _jsx(AppContextProvider, { children: _jsx(UserContextProvider, { children: _jsx(ModalContextProvider, { children: _jsx(PipelinesContextProvider, { children: _jsxs(LoadingContextProvider, { children: [currentPage, _jsx(ToastContainer, { position: "bottom-right" })] }) }) }) }) }) }));
}
export default App;
